import { render } from "./pb-spacer.vue?vue&type=template&id=470a1c8f"
import script from "./pb-spacer.vue?vue&type=script&lang=js"
export * from "./pb-spacer.vue?vue&type=script&lang=js"

import "./pb-spacer.vue?vue&type=style&index=0&id=470a1c8f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__